import script from "./RankList.vue?vue&type=script&setup=true&lang=js"
export * from "./RankList.vue?vue&type=script&setup=true&lang=js"

import "./RankList.vue?vue&type=style&index=0&id=5a0b1389&lang=scss&scoped=true"

import exportComponent from "/Users/zsrb/Documents/中山日报/2025/zsrb-news-detail/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a0b1389"]])

export default __exports__